<template>
    <b-form-group :label="label">
        <div class="d-flex" style="gap: 15px;align-items: center;">
            <DatePicker size="sm" :value="startDate" today-button reset-button :disabled="disabled"
                :clearable="clearable" @input="updateStartDate" />
            <DatePicker size="sm" :value="endDate" today-button reset-button :disabled="disabled" :clearable="clearable"
                @input="updateEndDate" />

            <b-dropdown size="sm" right :disabled="disabled">
                <b-dropdown-item @click="today">Today</b-dropdown-item>
                <b-dropdown-item @click="yesterday">Yesterday</b-dropdown-item>
                <b-dropdown-item @click="thisWeek">This Week</b-dropdown-item>
                <b-dropdown-item @click="lastWeek">Last Week</b-dropdown-item>
                <b-dropdown-item @click="last30Days">Last 30 Days</b-dropdown-item>
                <b-dropdown-divider v-if="clearable"></b-dropdown-divider>
                <b-dropdown-item v-if="clearable" @click="clearDates">Clear</b-dropdown-item>
            </b-dropdown>
        </div>
    </b-form-group>
</template>

<script>
import { DatePicker } from "element-ui";
import moment from 'moment';

export default {
    name: "DateRangeFilter",
    components: {
        DatePicker
    },
    props: {
        label: {
            type: String,
            default: "Date"
        },
        disabled: Boolean,
        value: Object,
        clearable: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        startDate() {
            return this.value.startDate;
        },
        endDate() {
            return this.value.endDate;
        }
    },
    watch: {
        startDate() {
            //console.log(this.startDate);
        }
    },
    methods: {
        updateStartDate(e) {
            if (!e && !this.clearable) {
                this.today();
                return;
            }
            if (!e) {
                this.$emit("input", { startDate: "", endDate: "" });
                return;
            }
            this.$emit("input", { startDate: e, endDate: this.endDate ? this.endDate : e });
        },
        updateEndDate(e) {
            if (!e && !this.clearable) {
                this.today();
                return;
            }
            if (!e) {
                this.$emit("input", { startDate: "", endDate: "" });
                return;
            }
            this.$emit("input", { startDate: this.startDate ? this.startDate : e, endDate: e });
        },
        today() {
            const today = new Date().toDateString();
            this.$emit("input", { startDate: today, endDate: today });
        },
        yesterday() {
            const yesterday = moment().subtract(1, 'day').toDate().toDateString();
            this.$emit("input", { startDate: yesterday, endDate: yesterday });
        },
        thisWeek() {
            this.$emit("input", {
                startDate: moment().startOf('week').toDate().toDateString(),
                endDate: moment().startOf('week').add(1, 'week').toDate().toDateString()
            });
        },
        lastWeek() {
            this.$emit("input", {
                startDate: moment().startOf('week').subtract(1, 'week').add(1, 'day').toDate().toDateString(),
                endDate: moment().startOf('week').subtract(1, 'week').add(1, 'week').toDate().toDateString()
            });
        },
        last30Days() {
            const today = new Date().toDateString();
            this.$emit("input", {
                startDate: moment().subtract(30, 'days').toDate().toDateString(),
                endDate: today
            });
        },
        clearDates() {
            this.$emit("input", { startDate: "", endDate: "" });
        }
    },
}

</script>

<style scoped>
/* The dashboard theme gives every button a 10px vertical margin, so the quick-range
   dropdown measures 20px taller than the pickers beside it. The row is centred, so that
   extra height pushes both pickers below the baseline consumers line up against -- the
   offset this component used to hide behind a margin-top: -7px on its own root. Removing
   the button's margin fixes the cause instead, and does so for every consumer rather
   than only the filter rows that opt into .aligned-controls. */
.d-flex ::v-deep .btn {
    margin-top: 0;
    margin-bottom: 0;
}
</style>
